import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";

export const reportsGridColumns: PolluxGridConfig[] = [
  {
    field: "checkbox",
    type: "checkbox",
    width: 40
  },
  {
    title: "report.publishStatus",
    field: "PublishStatusId",
    type: "special",
    width: 80,
    cellClass: "publish-status-field"
  },
  {
    title: "report.oid",
    field: "Oid",
    width: 200
  },
  {
    title: "report.valuerId",
    field: "ValuerIdDescription",
    width: 200
  },
  {
    title: "report.valuationDate",
    field: "ValuationDate",
    type: "date",
    width: 200
  },
  {
    title: "report.propertyName",
    field: "PropertyName",
    width: 200
  },
  {
    title: "report.propertyTypeId",
    field: "PropertyTypeIdDescription",
    width: 200
  },
  {
    title: "report.propertyMunicapelDescription",
    field: "PropertyMunicapelDescription",
    width: 200
  },
  {
    title: "report.propertyPostcode",
    field: "PropertyPostcode",
    width: 200
  },
  {
    title: "report.propertyStreet",
    field: "PropertyStreet",
    width: 280
  },
  {
    title: "report.statusId",
    field: "StatusIdDescription",
    width: 200
  },
  {
    title: "report.propertyId",
    field: "PropertyIdDescription",
    width: 200
  },
  {
    title: "report.propertyCountryDescription",
    field: "PropertyCountryDescriptionDescription",
    width: 200
  },
  {
    title: "report.projectStdId",
    field: "ProjectStdIdDescription",
    width: 200
  },
  {
    title: "report.valuationProjectId",
    field: "ValuationProjectIdDescription",
    width: 200
  },
  {
    title: "report.propertyIdNumber",
    field: "PropertyId",
    width: 200
  },
  {
    title: "report.ownerUserId",
    field: "OwnerUserIdDescription",
    width: 200
  },
  {
    title: "report.createdDate",
    field: "CreatedDate",
    type: "date",
    width: 200
  },
  {
    title: "report.modifiedByUserId",
    field: "ModifiedByUserIdDescription",
    width: 200
  },
  {
    title: "report.changeDate",
    field: "ChangeDate",
    type: "date",
    width: 200
  },
  {
    title: "report.recordStatusId",
    field: "RecordStatusIdDescription",
    width: 200
  },
  {
    title: "report.languageDefinition",
    field: "LanguageDefinition",
    width: 200
  }
];
